import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import SubHeading from 'components/common/SubHeading';
import i18n from 'i18n';

class DurationTableRaw extends React.Component {
  hideTransportDay(title) {
    return title === i18n.t('about:delivery:duration.transportDay') && this.props.rowNumber !== 0 ? 'hide' : ''
  }

  render() {
    const { paymentMethod } = this.props;

    return (
      <tr className='row'>
        {
          i18n.t(`about:delivery:duration.${paymentMethod}.additions`, { returnObjects: true })
            .map((addition, i) => (
              <td className={`col body ${this.hideTransportDay(addition.title)}`}
                key={i}
                rowSpan={i18n.t('about:delivery:duration.transportDay') === addition.title ? '2' : '1'}
              >
                <label>{addition.bodyPC}</label>
                {addition.tips && (
                  <ul className="tips">
                    {addition.tips.map((item, j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                )}
              </td>
            ))
        }
      </tr>
    )
  }
}

const DurationList = ({ className, paymentMethod }) => (
  <div className={`${className} duration`}>
    {
      i18n.t(`about:delivery:duration.${paymentMethod}.additions`, { returnObjects: true })
        .map((addition, i) => (
          <ul key={i} className="row">
            <li className="col title">{addition.title}</li>
            <li className="col body">
              <label>{addition.bodySP}</label>
              {addition.tips && (
                <ul className="tips">
                  {addition.tips.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              )}
            </li>
          </ul>
        ))
    }
  </div>
);

const Duration = ({ className }) => (
  <div className={className}>
    <SubHeading className='delivery-heading'>{i18n.t('about:delivery.subHeading')}</SubHeading>
    <div className="durations table-style">
      <div className='duration'>
        <table>
          <thead>
            <tr>
              <th>{i18n.t('about:delivery:duration.paymentMethod')}</th>
              <th>{i18n.t('about:delivery:duration.shipment')}</th>
              <th>{i18n.t('about:delivery:duration.transportDay')}</th>
              <th>{i18n.t('about:delivery:duration.scheduledDelivery')}</th>
            </tr>
          </thead>
          <tbody>
            {
              ['bank', 'credit'].map((paymentMethod, index) => (
                <DurationTableRaw key={index} rowNumber={index} paymentMethod={paymentMethod} />
              ))
            }
          </tbody>
        </table>
      </div>
    </div>
    <div className="durations list-style">
      <DurationList paymentMethod={'bank'} />
      <DurationList paymentMethod={'credit'} />
    </div>
  </div>
);

const commonStyle = css`
  .duration {
    .row {
      margin: 0;
      padding: 0;

      .col {
        vertical-align: middle;
        text-align: left;
        list-style: none;


        &.title {
          background: ${Colors.gray4};
          ${FontStyles.text8};
        }

        &.body {
          ${FontStyles.text7};
        }

        &:nth-of-type(1) {
          background: ${Colors.gray4};
        }

        &:nth-of-type(2) {
          text-align: left;
        }

        &:nth-of-type(3) {
          .tips {
            text-align: left;
          }
        }

        ul.tips {
          margin: 0;
          padding-left: 18px;

          li {
            list-style: none;
            position: relative;

            &:before {
              content: '※';
              position: absolute;
              left: -18px;
            }
          }
        }
      }
    }

    ul.row:nth-child(1) {
      border-top: 1px solid ${Colors.gray3};
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .list-style {
    display: none;
  }

  .delivery-heading {
    margin-bottom: 16px;
  }

  .duration {
    table {
      table-layout: fixed;
      width: 100%;

      th,td {
        border: 1px solid ${Colors.gray3};
      }

      th {
        ${FontStyles.text8};

        background: ${Colors.gray4};
        height: 58px;
      }

      .row {
        td.col {
          height: 56px;
          padding: 21px 16px;
          text-align: center;
          display: table-cell;
          vertical-align: middle;

          &.hide {
            display: none;
          }

          &.title {
            width: 160px;
          }

          &.body {
            white-space: pre-line;
            ul.tips {
              ${FontStyles.text10};
              padding-top: 6px;
            }
          }
        }
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  .delivery-heading {
    margin-bottom: 13px;
    ${FontStyles.text5};
  }

  .table-style {
    display: none;
  }
  .duration {
    padding: 16px 16px 0;
    margin-bottom: 16px;
    border: 1px solid ${Colors.gray3};

    ul.row {
      width: 100%;
      height: 56px;
      display: table;
      border-bottom: 1px solid ${Colors.gray3};

      li.col {
        display: block;
        padding: 12px 16px;

        &.title {
          width: 100%;
        }

        &.body {
          padding-bottom: 20px;

          ul.tips {
            ${FontStyles.text8};
            padding-top: 8px;
          }
        }
      }
    }

    ul.row:last-child {
      border-bottom: 0;
    }
  }
`;

export default applyStyles(Duration)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Delivery/components/Duration.js